import Typography from '@/components/shared/typography/typography.component';
import Image from 'next/image';
import { InfoCircleBlack } from 'public/Images';
import { AvailableCarIncludes, CarIncludesMap } from './car-includes.type';
import { AVAILABLE_LANGUAGES, colors } from '@/constants';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useAppSelector, useWindowDimensions } from '@/hook';
import { CarIncludesContent } from './CarIncludesContent';
import { CarDetailsType } from '@/types';
import { getCarType } from '../../car-type';
import { CarIncludeItem } from './car-includes-item';
import Button from '@/components/shared/Button/button-styled.component';
export const CarIncludes = ({
    lang,
    carDetails,
}: {
    lang: AVAILABLE_LANGUAGES;
    carDetails: CarDetailsType;
}) => {
    const { t } = useTranslation();
    const carType = getCarType(carDetails);
    const requiredIncludes = CarIncludesMap[carType];
    const toBeIncluded = requiredIncludes.map(i => AvailableCarIncludes[i]);
    const [openContent, setOpenContent] = useState(false);
    const { IS_DESKTOP } = useWindowDimensions();
    const { selectedCar } = useAppSelector(state => state.checkout);
    return (
        <div className="mb-6 md:mb-2">
            <div className="flex items-center gap-1.5 mb-3 mt-[18px]">
                <Typography
                    component="h2"
                    className="text-gray-800 text-body1SemiBold md:text-subtitle2SemiBold"
                >
                    {t('CarProfile.CarIncludesTitle', {
                        count: toBeIncluded.length,
                    })}
                </Typography>
                <Image
                    src={InfoCircleBlack}
                    alt="info"
                    width={IS_DESKTOP ? 18 : 16}
                    onClick={() => setOpenContent(true)}
                />
            </div>
            <div className="border border-gray-200 rounded-lg p-4 md:py-5 md:px-4">
                <div
                    className={`${
                        !IS_DESKTOP
                            ? 'mb-4 overflow-x-scroll scrollbar-hide'
                            : ''
                    }`}
                >
                    <div
                        className={`grid ${
                            IS_DESKTOP
                                ? 'grid-cols-3 grid-flow-row gap-y-4 gap-x-3'
                                : 'grid-rows-3 grid-flow-col w-max gap-y-3 gap-x-2.5'
                        } `}
                    >
                        {toBeIncluded.map((item, idx) => {
                            return (
                                <CarIncludeItem
                                    item={item}
                                    key={idx}
                                    lang={lang}
                                />
                            );
                        })}
                    </div>
                </div>
                {!IS_DESKTOP && (
                    <div>
                        <Button
                            onClick={() => setOpenContent(true)}
                            className="w-full bg-white py-[10px] px-4"
                            style={{
                                border: `1px solid ${colors['gray-300']}`,
                            }}
                        >
                            <Typography
                                variant="body2Medium"
                                className="text-primary-700"
                            >
                                {t('CarProfile.BenfitsDetails')}
                            </Typography>
                        </Button>
                    </div>
                )}
            </div>
            {openContent && (
                <CarIncludesContent
                    open={openContent}
                    setOpen={setOpenContent}
                    IS_DESKTOP={IS_DESKTOP}
                    showCarDetailsHeader={true}
                    selectedCar={selectedCar}
                    carType={carType}
                />
            )}
        </div>
    );
};
